<p-confirmDialog key="hssettings" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainBorder">
	<h4 style="text-align: center">Consequence Settings</h4>

	<div class="AccumulationGrid">
		<label>Count hall sweeps from <span *ngIf="AccumulationMode != 0">the last </span></label>
		<input
			*ngIf="AccumulationMode != 0"
			[disabled]="IsLoading() == true"
			type="number"
			min="1"
			class="form-control"
			[(ngModel)]="AccumulationCount"
			(ngModelChange)="onAccumulationCountChange($event)"
		/>
		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="AccumulationMode"
			[(ngModel)]="AccumulationMode"
			(ngModelChange)="onAccumulationModeChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstAccumulationMode" [ngValue]="o.ID">
				{{ o.Desc }}
			</option>
		</select>
	</div>

	<div class="TopMargin" style="text-align: center" *ngIf="AccumulationMode != 0">
		<label>Ex. Since {{ ExampleDateDesc }}</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
